module.exports = __webpack_public_path__ + "static/media/activeGoal.09a6f7d1.svg";